import types from './types';

const setConfig = config => ({
  type: types.SET_CONFIG,
  payload: {
    config
  }
});

const setOriginFieldInfos = fieldInfos => ({
  type: types.SET_ORIGIN_FIELD_INFOS,
  payload: {
    fieldInfos
  }
});

const initUserPrefs = (id, preferences) => ({
  type: types.INIT_USER_PREFS,
  payload: {
    id,
    preferences
  }
});

const addSqlFilter = filterDef => ({
  type: types.ADD_SQL_FILTER,
  payload: {
    filterDef
  }
});

const renameSqlFilter = filterRenameInfo => ({
  type: types.RENAME_SQL_FILTER,
  payload: {
    filterRenameInfo
  }
});

const removeSqlFilter = name => ({
  type: types.REMOVE_SQL_FILTER,
  payload: {
    name
  }
});

const addResourceSqlFilter = filterDef => ({
  type: types.ADD_SQL_FILTER,
  payload: {
    isResources: true,
    filterDef
  }
});

const renameResourceSqlFilter = filterRenameInfo => ({
  type: types.RENAME_SQL_FILTER,
  payload: {
    isResources: true,
    filterRenameInfo
  }
});

const removeResourceSqlFilter = name => ({
  type: types.REMOVE_SQL_FILTER,
  payload: {
    isResources: true,
    name
  }
});

const setIncidentListColumns = columns => ({
  type: types.SET_INCIDENT_LIST_COLUMNS_PREFS,
  payload: {
    columns
  }
});

const setIncidentResourceListColumns = columns => ({
  type: types.SET_INCIDENT_RESOURCE_LIST_COLUMNS_PREFS,
  payload: {
    columns
  }
});

const setIncidentRequestListColumns = columns => ({
  type: types.SET_INCIDENT_REQUEST_LIST_COLUMNS_PREFS,
  payload: {
    columns
  }
});

const setIncidentExperienceListColumns = columns => ({
  type: types.SET_INCIDENT_EXPERIENCE_LIST_COLUMNS_PREFS,
  payload: {
    columns
  }
});

const setResourceListColumns = columns => ({
  type: types.SET_RESOURCE_LIST_COLUMNS_PREFS,
  payload: {
    columns
  }
});

const setMapPrefs = mapColumnVisible => ({
  type: types.SET_MAP_PREFS,
  payload: {
    mapColumnVisible
  }
});

export default {
  setConfig,
  setOriginFieldInfos,
  initUserPrefs,

  addSqlFilter,
  renameSqlFilter,
  removeSqlFilter,
  addResourceSqlFilter,
  renameResourceSqlFilter,
  removeResourceSqlFilter,

  setIncidentListColumns,
  setIncidentResourceListColumns,
  setIncidentRequestListColumns,
  setIncidentExperienceListColumns,
  setResourceListColumns,
  setMapPrefs
};



// WEBPACK FOOTER //
// ./src/redux/config/actions.js